// extracted by mini-css-extract-plugin
module.exports = {"newhouse":"StoryNewHouse_newhouse__hQVMs","mobile_newhouse":"StoryNewHouse_mobile_newhouse__avORh"};